import React from "react";
import { LessonI, ModuleI, PageI } from "../types";
import { TutorialTipDirection } from "../componentLibrary/TutorialTip";
import AddToToolboxButton from "./AddToToolboxButton";

export default function FavoriteButton({
  page,
  module,
  lesson,
  showTutorial = true,
  tutorialPosition = "left",
  answers = {},
}: {
  page: PageI;
  confirmDelete?: boolean;
  module?: ModuleI;
  lesson?: LessonI;
  showTutorial?: boolean;
  tutorialPosition?: TutorialTipDirection;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  answers?: Record<string, any>;
}) {
  return (
    <AddToToolboxButton
      page={page}
      module={module}
      lesson={lesson}
      showTutorial={showTutorial}
      tutorialPosition={tutorialPosition}
      answers={answers}
    />
  );
}
